import * as Connector from 'shared/connectors/partnerConnector';
import { PARTNER } from 'store/types';

const init = () => ({
  type: PARTNER.GET_ATTACHED_ADVISERS_INIT,
});

export const success = data => ({
  type: PARTNER.GET_ATTACHED_ADVISERS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: PARTNER.GET_ATTACHED_ADVISERS_FAILURE,
});

const getAttachedAdvisers = uuid => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getAttchedAdvisers(uuid);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getAttachedAdvisers;
